module.exports = __webpack_public_path__ + "img/8电线电缆网.9ecce8ed.png";